/* unplugin-vue-components disabled */import script from "./TextBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./TextBlock.vue?vue&type=script&setup=true&lang=js"

import "./TextBlock.vue?vue&type=style&index=0&id=7a89bd2f&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a89bd2f"]])

export default __exports__